export default {
  title: "title",
  springFestival: {
    modalTitle: "Happy Chinese New Year!",
    modalMessage: "On this festive occasion, Henan Yunchi Machinery Equipment Co., Ltd. wishes you and your family good health, prosperity, and success!"
  },
  contact: {
    formTitle: "Customer Message",
    formSubtitle: "If you have any questions or needs, please feel free to contact us, we will reply to you as soon as possible",
    name: "Name",
    namePlaceholder: "Please enter your name",
    email: "Email",
    emailPlaceholder: "Please enter your email address",
    phone: "Phone",
    phonePlaceholder: "Please enter your phone number",
    message: "Message",
    messagePlaceholder: "Please enter your message",
    submit: "Submit Message",
    submitting: "Submitting...",
    successTitle: "Submission Success",
    successMessage: "Your message has been successfully submitted, we will contact you soon!",
    required: "This field is required"
  },
  nav: {
    home: "Home",
    products: "Products",
    about: "About",
    story: "Our Story"
  },
  home: {
    companyTitle: "Machinery and equipment factory",
    companyDescription1: "China Henan Yunchi Machinery Equipment Co., Ltd. was established on May 3, 2016.",
    companyDescription2: "Mainly engaged in the research and development, production and sales of machinery and equipment.",
    companyDescription3: "Including partition board installation series, construction industry mixing series, etc.",
    companyDescription4: "Integrating production, sales and after-sales service, it is well-known among similar products in China and is exported to Southeast Asia, West Asia, the Middle East, Africa, Europe and the United States."
  },
  product: {
    badge: "Premium Equipment",
    title: "Our Products",
    subtitle: "Discover our premium industrial equipment, engineered for excellence and built to last",
    contactUs: "Contact Us",
    getQuote: "Get Quote",
    learnMore: "Learn More",
    ctaTitle: "Need a Custom Solution?",
    ctaSubtitle: "Our expert team is ready to help you find the perfect equipment for your specific requirements",
    whatsappMessage: "I'm interested in: ",
    customizable: "If you need to inquire about other specifications, please contact us! Can be customized!",

    highSpeedDisperser: "High-speed Disperser",
    highSpeedDisperserParams: "Power: 22kW | Size: 1.9×0.8×1.85m",

    mixerProductionLine: "Mixer Production Line",
    mixerProductionLineParams: "Main Motor: 11KW | Loading: 4KW | Capacity: 1 ton",

    chiliShearing: "Chili Shearing Machine",
    chiliShearingParams: "Size: 5.05×3.33×2.5m | Power: 8.8kW",

    wallPanelInstaller: "Wall Panel Installation Machine",
    wallPanelInstallerParams: "Lifting: 1500W | Walking: 800W | Voltage: 48V",

    portableCuttingSaw: "Portable Cutting Saw",
    portableCuttingSawParams: "Dimensions: 94.5×26×55.8cm",

    suctionCupInstaller: "Suction Cup Glass Installer",
    suctionCupInstallerParams: "Lifting: 1500W | Walking: 1200W | Voltage: 48V",

    inclinedPalletTruck: "Inclined Pallet Truck",
    inclinedPalletTruckParams: "Dimensions: 1.3×0.7m",

    stonePaintMixer: "Real Stone Paint Mixer",
    stonePaintMixerParams: "Main Motor: 7.5KW | Loading: 4KW | Capacity: 1 ton"
  },
  footer: {
    description: "We have a dedicated team of professionals who design durability and efficiency for every product. Over the years, our commitment to quality has won us an increasing number of global customers—from China to overseas markets. Integrated innovation—from blueprint to finished product, we control every detail. Industry applicability—machines designed to meet different operational needs. Proven reliability—years of satisfied customers prove our standards.",
    products: "Products",
    highSpeedDisperser: "High-speed Disperser",
    mixerProductionLine: "Mixer Production Line",
    chiliShearing: "Chili Shearing Machine",
    wallPanelInstaller: "Wall Panel Installation Machine",
    portableCuttingSaw: "Portable Cutting Saw",
    suctionCupInstaller: "Suction Cup Glass Installer",
    company: "Company",
    aboutUs: "About Us",
    allProducts: "All Products",
    contact: "Contact",
    address: "Luohe, Henan Province, China",
    rights: "All rights reserved",
    privacy: "Privacy Policy",
    terms: "Terms of Service"
  },
  about: {
    contactInfo: "Contact Information",
    addressLabel: "Address",
    address: "50 meters southeast of the intersection of Y043 and Yingsong East Road, Lin'ying County, Luohe City, Henan Province",
    whatsapp: "What'sApp",
    facebook: "Facebook",
    tiktok: "Tiktok",
    youtube: "Youtube",
    twitter: "Twitter",
    email: "Email",
    companyName: "Company name"
  },
  story: {
    title: "Our Story",
    subtitle: "Craftsmanship Knows No Boundaries",
    section1: {
      year: "2016",
      title: "The Beginning",
      content: "In 2016, wind in Henan blew awake the original intention of Yunchi. Guo Haolei, together with a group of craftsmen, polished the first wall panel installation machine in the factory. The seed of 'doing things down-to-earth and striving for excellence' took root in sweat."
    },
    section2: {
      year: "2016",
      title: "Craftsmanship Knows No Boundaries",
      content: "A Singaporean businessman traveled all over the world to find such equipment but found nothing. Finally, after asking around, he found this factory. When he saw the solid body of the machine, his eyes burst with ecstasy. Only then did we realize that there are many places around the world that need such equipment. This made Yunchi people suddenly understand: craftsmanship knows no boundaries, and the efforts in their hands are the light that the world longs for."
    },
    section3: {
      year: "Present",
      title: "Quality as Promise",
      content: "With quality as promise, with service as warmth. The continuous orders and active referrals from the Singaporean customer are the most touching rewards. Today, Yunchi is still improving, iterating products to meet overseas needs, and perfecting after-sales service across mountains and seas. This persistence allows Chinese intelligent manufacturing to sail steadily in the international wave."
    },
    values: {
      title: "Our Values",
      quality: "Quality as Promise",
      qualityDesc: "Committed to excellence, creating trustworthy products",
      service: "Service as Warmth",
      serviceDesc: "Providing comprehensive after-sales support across the globe",
      innovation: "Continuous Improvement",
      innovationDesc: "Innovating continuously to meet evolving needs"
    }
  }
};